import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {isLogin} from "./AuthController";

const ProtectedRoute = () => {
    return isLogin() ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
